import { useL10n } from '@uplift/hooks';
import { PasswordAdornment, PasswordField, TextInput } from '../../../../Inputs';
import { useState } from 'react';
import { Box } from '@mui/material';

type PasswordVisibilityKey = 'currentPassword' | 'confirmNewPassword';
type PasswordVisibilityState = Record<PasswordVisibilityKey, boolean>;

export const ChangePasswordForm = () => {
  const l10n = useL10n();

  const [ passwordVisibility, setPasswordVisibility ] = useState<PasswordVisibilityState>({
    currentPassword: false,
    confirmNewPassword: false,
  });

  const onPasswordVisibilityClick = (key: PasswordVisibilityKey) => setPasswordVisibility(p => ({ ...p, [key]: !p[key] }));

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        maxWidth: '400px'
      }}
    >
      <TextInput
        label={l10n.updatePassword.currentPassword}
        type={passwordVisibility.currentPassword ? 'text' : 'password'}
        name="currentPassword"
        fullWidth
        endAdornment={(
          <PasswordAdornment
            handleClick={() => onPasswordVisibilityClick('currentPassword')}
            showPassword={passwordVisibility.currentPassword}
          />
        )}
      />
      <PasswordField
        label={l10n.updatePassword.newPassword}
        name="newPassword"
        stackValidatorsOnMobile
      />
      <TextInput
        label={l10n.updatePassword.confirmNewPassword}
        name="confirmNewPassword"
        type={passwordVisibility.confirmNewPassword ? 'text' : 'password'}
        fullWidth
        endAdornment={(
          <PasswordAdornment
            handleClick={() => onPasswordVisibilityClick('confirmNewPassword')}
            showPassword={passwordVisibility.confirmNewPassword}
          />
        )}
      />
    </Box>
  );
};
